<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left py-3">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Default Settings</h2>
          <p class="text-purple-manax pl-3 subtitle-section">Listado de Opciones configurables del Sistema - Valores por defecto</p>
        </span>
        <span class="pull-right py-3 pr-3">
          <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openCompanySettings()">
            <i class="material-icons">settings</i>&nbsp;<span class="d-none d-sm-inline">Ver por Empresa</span>
          </button>
        </span>
        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortSettings($event)" stickyHeader
          stickyFooter>

          <thead class="text-lavuro">
            <tr>

              <!-- All -->
              <th class="p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell" mat-sort-header="code">
                Codigo
              </th>
              <th class="d-none d-md-table-cell" mat-sort-header="name">
                Nombre
              </th>
              <th class="d-none d-md-table-cell">
                Default
              </th>

              <!-- Mobile -->
              <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{sortOptions[filter.sort ?? ''] || 'ninguno'}}</span>
                <span class="text-lavuro pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                    <span>Filtros</span>
                  </button>
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortSettings(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortSettings('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let setting of settings" [class.text-danger]="setting.isDeleted" class='cursor-pointer'
              (click)="openSettingModal(setting)">

              <!-- All -->
              <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(setting._id)"
                      [checked]="selection.all || selection[setting._id || '']">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{setting.code}}</td>
              <td class="d-none d-md-table-cell">{{setting.name}}</td>
              <td class="d-none d-md-table-cell">{{setting.defaultValue}}</td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <b>{{setting.code}}</b><br>
                {{setting.name}}<br>
                default: {{setting.defaultValue}}<br>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openSettingModal(setting, true)">
                    <span>Abrir</span>
                  </button>
                  <button mat-menu-item (click)="openSettingModal(setting)">
                    <span>Modificar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ settings.length }} settings</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>